import { render, staticRenderFns } from "./ItemActivity.vue?vue&type=template&id=1cb739e2&scoped=true"
import script from "./ItemActivity.vue?vue&type=script&lang=js"
export * from "./ItemActivity.vue?vue&type=script&lang=js"
import style0 from "./ItemActivity.vue?vue&type=style&index=0&id=1cb739e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb739e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb739e2')) {
      api.createRecord('1cb739e2', component.options)
    } else {
      api.reload('1cb739e2', component.options)
    }
    module.hot.accept("./ItemActivity.vue?vue&type=template&id=1cb739e2&scoped=true", function () {
      api.rerender('1cb739e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/marketingEvents/component/ItemActivity.vue"
export default component.exports